import { Swap } from '../../logic/swaps/Swap'

import { DefaultViewState } from '../pools/deposit/DepositState'

// Written here for auto-completion
export const SwapState = {
  CONNECT: new DefaultViewState('CONNECT').withMessage('Connect a wallet'),
  CHOOSE_TOKEN: new DefaultViewState('CHOOSE_TOKEN').withMessage(
    'Choose a token'
  ),
  CHOOSE_AMOUNT: new DefaultViewState('CHOOSE_AMOUNT').withMessage(
    'Choose an amount'
  ),
  SWAPPABLE: new DefaultViewState('SWAPPABLE').withMessage('Swap'),
  // Rename as NOT_SWAPPABLE because not enough liquidity or imbalanced
  NO_LIQUIDITY: new DefaultViewState('NO_LIQUIDITY').withMessage(
    'Not enough liquidity'
  ),
  PREVIEW: new DefaultViewState('PREVIEW').withMessage('Preview'),
  ACCEPTANCE_LOADING: new DefaultViewState('ACCEPTANCE_LOADING').withMessage(
    'Loading....'
  ),
  ACCEPTANCE_DONE: new DefaultViewState('ACCEPTANCE_DONE').withMessage(
    'Accepted'
  ),
  ACCEPTANCE_FAILED: new DefaultViewState('ACCEPTANCE_FAILED').withMessage(
    'Swap again'
  ),
  SUBMITTING: new DefaultViewState('SUBMITTING').withMessage('Submitting tx..'),
  PROCESSING: new DefaultViewState('PROCESSING').withMessage('Processing tx..'),
  TRANSACTION_SUCCESS: new DefaultViewState('TRANSACTION_SUCCESS').withMessage(
    'Success'
  ),
  TRANSACTION_FAILED: new DefaultViewState('TRANSACTION_FAILED').withMessage(
    'Failure'
  ),
}

const allStates = Object.values(SwapState)
allStates.forEach(state => (state.states = allStates))
